// components/guards/RequirePlanSelected.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useUserDoc } from "../../hooks/useUserDoc";
import { atLeast } from "../../utils/onboarding";

export default function RequirePlanSelected({ children }) {
  const { loading, data } = useUserDoc();
  if (loading) return null;
  return atLeast(data?.onboarding?.step, "planSelected") ? (
    children
  ) : (
    <Navigate to="/payment" replace />
  );
}
